<template lang="pug">
div
  span.anchor-text(v-if="anchorText !== ''") {{ anchorText }}
  v-text-field(
    ref="input"
    v-model="inputComputed"
    :clearable="clearable" 
    :rules="rules"
    :disabled="disabled"
    :type="type"
    :readonly="readonly"
    :placeholder="placeholder"
    :height="isMobile ? mobileHeight : desktopHeight"
    filled
    :counter="counter"
    :dark="dark"
    outlined
    full-width
    :dense="!isMobile"
    :hide-details="hideDetailsComputed"
    :append-icon="appendIcon"
    :validate-on-blur="validateOnBlur"
    :data-cy="dataCy"
    :maxlength="maxlength"
    :prepend-icon="prependIcon"
    :loading="loading"
    v-bind="attrs"
    v-on="on"
    @click:append="$emit('click:append')"
    @click:clear="$emit('click:clear')"
    @blur="$emit('blur')"
    @change="$emit('change')"
    @keyup.enter="$emit('keyup.enter')"
    @keypress="$emit('keypress', $event)"
  )
    template(v-if="!appendIcon" #append)
      slot(name="append")
    template(#prepend)
      slot(name="prepend")
    template(v-if="label !== ''" #label)
      span.label-text-dark(v-if="dark") {{ label }}
      span.label-text(v-else) {{ label }}
</template>

<script>
import heights from "@/mixins/utils/Heights.js";
export default {
  name: "TextFieldComponent",
  mixins: [heights],
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    anchorText: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "text",
    },
    appendIcon: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    validateOnBlur: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    attrs: {
      type: Object,
      default: () => {},
    },
    on: {
      type: Object,
      default: () => {},
    },
    counter: {
      type: [Number, String],
      default: undefined,
    },
    dataCy: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    prependIcon: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputComputed: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    hideDetailsComputed() {
      if (this.counter) return false;
      return this.hideDetails;
    },
  },
  methods: {
    resetValidation() {
      const input = this.$refs["input"];
      if (input) input.resetValidation();
    },
  },
};
</script>

<style lang="sass" scoped>
.label-text
  font-size: 14px
  line-height: 120%
  font-weight: 400
  color: var(--v-label-base)

.label-text-dark
  font-size: 14px
  line-height: 120%
  font-weight: 400

.anchor-text
  font-weight: 400
  font-size: 14px
  line-height: 120%
  color: var(--v-anchorText-base)
</style>
